import _ from 'underscore';
import $ from 'jquery';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const AdsEditorView = globalContext.requireDefault('campaignui/feature/crud-ad/view/index');
const appConfig = globalContext.require('component/config/index');
const layout = globalContext.require('module/app/layout/index');
const SummaryDataContextManager = globalContext.require('SummaryDataContextManager');
const permissions = appConfig.get('Permissions') || {};
const {
  IsImpressionTrackingUrlsEnabled,
  IsAmplifyEnabled,
  EnableIASVerifiedImpressionTrackingURLsForBrandAwarenessCampaign,
  dynamic = {},
} = permissions;
const {
  XandrDisplayAdsCampaigns,
  EnableDisplayAdsIasTracking,
  MultiAdFormat,
} = dynamic;

const isIASForAdEnabled = EnableIASVerifiedImpressionTrackingURLsForBrandAwarenessCampaign || (XandrDisplayAdsCampaigns && EnableDisplayAdsIasTracking);

const currentAdGroup = appConfig.get('CurrentAdGroup');

function getUpgradedUrl(item) {
  const {
    FinalUrls, Type, MobileFinalUrls, UrlCustomParameters, TrackingUrlTemplate, FinalUrlSuffix,
    DestinationUrl,
  } = item;
  const isFinal = Type === 'DynamicSearch' ?
    !_.isEmpty(UrlCustomParameters) || !_.isEmpty(TrackingUrlTemplate) ||
    !_.isEmpty(FinalUrlSuffix) :
    !_.isEmpty(FinalUrls);

  if (isFinal) {
    return {
      FinalUrls,
      MobileFinalUrls,
      TrackingUrlTemplate,
      UrlCustomParameters,
      FinalUrlSuffix,
    };
  }

  return {
    DestinationUrl,
  };
}

function getBiddingScheme(item) {
  const biddingStrategyType = _.get(item, 'Campaign.DisplayBiddingStrategyType');
  if (!_.isString(biddingStrategyType || _.isEmpty(biddingStrategyType))) {
    return {};
  }

  return { BiddingScheme: { Type: biddingStrategyType } };
}

function getModelForCreateOrEdit(item) {
  const {
    Id,
    Type,
    Text,
    TextPart2,
    Title,
    FinalUrls,
    MobileFinalUrls,
    NativePreference,
    DevicePreference,
    DisplayUrl,
    PromotionalText,
    TitlePart1,
    TitlePart2,
    TitlePart3,
    Path1,
    Path2,
    AppStoreId,
    AppPlatform,
    Headline,
    LongHeadline,
    TrackingUrlTemplate,
    FinalUrlSuffix,
    UrlCustomParameters,
    BusinessName,
    LandscapeImageMediaId,
    SquareImageMediaId,
    LandscapeLogoMediaId,
    SquareLogoMediaId,
    CallToAction,
    CallToActionLanguage,
    CallToActionText,
    CallToActionAriaText,
    MediaUrl,
    DeviceType,
    AltText,
    Headlines,
    LongHeadlines,
    Descriptions,
    Images,
    ImpressionTrackingUrls,
    VerifiedTrackingSettings,
    Videos,
    BoostAnchors,
    HotSpots,
    Campaign,
    AdSubType,
    LegacyResponsiveAd,
  } = item;
  switch (Type) {
    case 'Text':
      return _.extend({
        Id,
        Type,
        Title,
        Text,
        DisplayUrl,
        DevicePreference,
        NativePreference,
      }, getUpgradedUrl(item));
    case 'ExpandedText':
      return _.extend({
        Id,
        Type,
        Text,
        TextPart2,
        TitlePart1,
        TitlePart2,
        TitlePart3,
        Path1,
        Path2,
        NativePreference,
        DisplayUrl,
      }, getUpgradedUrl(item));
    case 'Product':
      return {
        Id,
        Type,
        PromotionalText,
      };
    case 'AppInstall':
      return _.extend({
        Id,
        Type,
        Title,
        Text,
        AppStoreId,
        AppPlatform,
        AltText,
        DeviceType,
        MediaUrl,
        DevicePreference,
      }, getUpgradedUrl(item));
    case 'DynamicSearch':
      return _.extend({
        Id,
        Type,
        Text,
        TextPart2,
        DisplayUrl,
        Path1,
        Path2,
        DevicePreference,
      }, getUpgradedUrl(item));
    case 'ResponsiveSearch':
      return _.extend({
        Id,
        Type,
        Headlines,
        Descriptions,
        Path1,
        Path2,
        NativePreference,
        DisplayUrl,
      }, getUpgradedUrl(item));
    case 'Responsive':
    default:
      return _.extend(
        IsAmplifyEnabled ? { HotSpots } : {},
        IsAmplifyEnabled ? { BoostAnchors } : {},
        {
          Id,
          FinalUrls,
          MobileFinalUrls,
          TrackingUrlTemplate,
          UrlCustomParameters,
          Text,
          Type,
          BusinessName,
          Headline,
          LongHeadline,
          Headlines,
          LongHeadlines,
          Descriptions,
          LandscapeImageMediaId,
          SquareImageMediaId,
          LandscapeLogoMediaId,
          SquareLogoMediaId,
          CallToAction,
          CallToActionLanguage,
          CallToActionText,
          CallToActionAriaText,
          Images,
          Videos,
          FinalUrlSuffix,
          Campaign,
          LegacyResponsiveAd,
        },
        getBiddingScheme(item),
        IsImpressionTrackingUrlsEnabled ? { ImpressionTrackingUrls } : {},
        isIASForAdEnabled ? { VerifiedTrackingSettings } : {},
        MultiAdFormat ? { AdSubType } : {}
      );
  }
}

export function initializeAdEditor({
  scope,
  gridView,
  item = {},
  firstTextItem = {},
  firstExpandedItem = {},
  firstResponsiveSearchItem = {},
  isForVNext = false,
  newI18n,
  inlineSuggestionsEnabled = false,
  lazyInject,
  showSaveAndCreateAnother = true,
  isOpenCreatePanel = false,
  shouldSendOpportunityLog,
  logOpportunity,
  perfMarker,
  serverContext,
  preferenceService,
  triggerAdItemRefresh = false,
  navigateToSingleAdEditor = _.noop,
  loadClipchampPlayer,
}) {
  const parameters = _.extend({
    className: isForVNext ? 'panel' : '',
    isForVNext,
    newI18n,
    inlineSuggestionsEnabled,
    isTraditionalChinese: currentAdGroup && currentAdGroup.Language === 24,
    campaignType: item && item.Campaign ? item.Campaign.CampaignType : null,
    campaignSubType: item && item.Campaign ? item.Campaign.CampaignSubType : null,
    isDynamicDescriptionEnabled: item && item.Campaign && item.Campaign.CampaignSettings ? _.result(_.first(item.Campaign.CampaignSettings), 'DynamicDescriptionEnabled') : null,
    showSaveAndCreateAnother,
    isOpenCreatePanel,
    shouldSendOpportunityLog,
    logOpportunity,
    parentPerfMarker: perfMarker,
    serverContext,
    preferenceService,
    loadClipchampPlayer,
  }, scope);

  if (!_.isEmpty(item)) {
    parameters.model = getModelForCreateOrEdit(item);
  }

  if (!_.isEmpty(firstTextItem)) {
    parameters.firstTextAdModel = getModelForCreateOrEdit(firstTextItem);
  }
  if (!_.isEmpty(firstExpandedItem)) {
    parameters.firstExpandedTextAdModel = getModelForCreateOrEdit(firstExpandedItem);
  }
  if (!_.isEmpty(firstResponsiveSearchItem)) {
    parameters.firstResponsiveSearchAdModel = getModelForCreateOrEdit(firstResponsiveSearchItem);
  }

  if (parameters.campaignType === 'LinkedIn') {
    navigateToSingleAdEditor({
      campaignId: item.Campaign.Id,
      adGroupId: item.AdGroup.Id,
      adId: item.Id,
    });
    return;
  }

  const adEditor = new AdsEditorView(parameters);
  const backboneGridView = lazyInject ? lazyInject().backboneGridView : gridView;
  const { gridDidUpdateHandler } = backboneGridView;

  if (isForVNext) {
    backboneGridView.overrideWith(adEditor.render());

    adEditor.on('close', () => {
      backboneGridView.overrideWith(null);
      adEditor.remove();
      if (_.isFunction(gridDidUpdateHandler)) {
        gridDidUpdateHandler();
      }
    });

    adEditor.on('adgroup selected', (adGroup) => {
      if (_.get(adGroup, 'Campaign.CampaignType') !== 'LinkedIn') { return; }

      navigateToSingleAdEditor({
        campaignId: adGroup.Campaign.Id,
        adGroupId: adGroup.Id,
      });
    });
  } else {
    const editSelector = '#adEditContainer';
    const editorContainer = $(editSelector);

    editorContainer.empty().append(adEditor.render().el).show();
    const el = editorContainer.find('.form-control:visible:first');
    if (el) {
      el.focus();
    }

    layout.scrollTo(editorContainer);
    const { toolbar } = gridView.grid;
    const gridContainer = gridView.$el.closest('.bingadsgrid');
    const gridToolbar = gridContainer.find('.grid-toolbar');
    gridToolbar.hide();
    toolbar.gridToolbarGroup.hideAllToolbars();

    adEditor.on('close', () => {
      // show toolbar
      gridToolbar.show();
      editorContainer.hide();
      toolbar.gridToolbarGroup.showAllToolbars();
      adEditor.remove();
    });
  }

  adEditor.on('save', () => {
    SummaryDataContextManager.updateContext(['AdGrid']);
    backboneGridView.view.refresh(true);
    if (triggerAdItemRefresh) {
      backboneGridView.grid.showAdStrength.refreshAdItem();
    }
  });
}
